// @flow

import { logger } from '../../../common'

import { createMetricEvent } from '../../../common/api/chatchampApi'

import {
  type Wizard$StartedEventPayload,
  type Wizard$LoadedEventPayload,
  type Wizard$CompletedEventPayload,
  type Wizard$RecommendedProductClickedEventPayload,
  WIZARD_EVENTS
} from '../types'

function createLoadedMetricEvent (eventPayload: Wizard$LoadedEventPayload): void {
  createMetricEvent(eventPayload.customerId, eventPayload.subscriberId, 'impression', 'wizard_landing_page_visit', {
    wizardId: eventPayload.wizardId,
    landingPageId: eventPayload.landingPageId
  }).catch((error) => logger.error(error))
}

function createStartedMetricEvent (eventPayload: Wizard$StartedEventPayload): void {
  createMetricEvent(eventPayload.customerId, eventPayload.subscriberId, 'activation', 'wizard_landing_page_button_click', {
    wizardId: eventPayload.wizardId,
    landingPageId: eventPayload.landingPageId
  }).catch((error) => logger.error(error))
}

function createCompletedMetricEvent (eventPayload: Wizard$CompletedEventPayload): void {
  createMetricEvent(eventPayload.customerId, eventPayload.subscriberId, 'completion', 'wizard_recommended_products_view', {
    wizardId: eventPayload.wizardId,
    productIds: eventPayload.productIds
  }).catch((error) => logger.error(error))
}

function createRecommendedProductClickedEvent (eventPayload: Wizard$RecommendedProductClickedEventPayload): void {
  createMetricEvent(eventPayload.customerId, eventPayload.subscriberId, 'clickout', 'wizard_recommended_product_click', {
    wizardId: eventPayload.wizardId,
    productId: eventPayload.productId
  }).catch((error) => logger.error(error))
}

const eventsWrapper = {
  loaded: ({ detail }) => createLoadedMetricEvent(detail),
  started: ({ detail }) => createStartedMetricEvent(detail),
  completed: ({ detail }) => createCompletedMetricEvent(detail),
  recommendedProductClicked: ({ detail }) => createRecommendedProductClickedEvent(detail)
}

export function registerMetricEventListeners (): void {
  if (window.trboAdvisorRegisteredMetricEventListeners) return

  window.trboAdvisorRegisteredMetricEventListeners = true
  window.addEventListener(WIZARD_EVENTS.Loaded, eventsWrapper.loaded)
  window.addEventListener(WIZARD_EVENTS.Started, eventsWrapper.started)
  window.addEventListener(WIZARD_EVENTS.Completed, eventsWrapper.completed)
  window.addEventListener(WIZARD_EVENTS.RecommendedProductClicked, eventsWrapper.recommendedProductClicked)
}
